import React from "react";
import * as styles from "./Banner.module.scss";

const ContactBanner = () => {
  return (
    <section className={`${styles.SectionBanner} section`}>
      <div className="container">
        <div className={styles.LeftContainer}>
          <div className={styles.TextContainer}>
            <h2>Contacto</h2>
          </div>
        </div>
        <div className={styles.RightContainer}></div>
      </div>
    </section>
  );
};

export default ContactBanner;
